// extracted by mini-css-extract-plugin
export default {"main_div":"FormModal_main_div__Ytbqb","error_msg":"FormModal_error_msg__Y+Urj"};